export const randomInRangeHelper = (min: number, max: number) =>
  Math.random() * (max - min) + min;
